/* unplugin-vue-components disabled */import script from "./searchInput.vue?vue&type=script&setup=true&lang=js"
export * from "./searchInput.vue?vue&type=script&setup=true&lang=js"

import "./searchInput.vue?vue&type=style&index=0&id=72722681&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72722681"]])

export default __exports__